export default {
  documentTypeImageTypeDict: {},
}
